var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Choose Your Layout ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("p", [
                    _vm._v(
                      " Select the layout to use as the starting point for your website. "
                    )
                  ]),
                  _c(
                    "v-item-group",
                    {
                      attrs: {
                        mandatory: ""
                      },
                      model: {
                        value: _vm.theme,
                        callback: function callback($$v) {
                          _vm.theme = $$v
                        },
                        expression: "theme"
                      }
                    },
                    [
                      _c(
                        "v-row",
                        _vm._l(_vm.secondStep.themes, function(item, i) {
                          return _c(
                            "v-col",
                            {
                              key: i,
                              attrs: {
                                cols: "12",
                                md: "3"
                              }
                            },
                            [
                              _c("v-item", {
                                attrs: {
                                  value: item.key
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function fn(_ref) {
                                        var active = _ref.active,
                                          toggle = _ref.toggle
                                        return [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass: "app-card",
                                              on: {
                                                click: toggle
                                              }
                                            },
                                            [
                                              _c(
                                                "v-card-text",
                                                {
                                                  staticClass:
                                                    "text-center pa-0",
                                                  style: active
                                                    ? "border: 2px solid #0ca750 !important"
                                                    : ""
                                                },
                                                [
                                                  _c("v-img", {
                                                    staticClass:
                                                      "d-flex align-center ma-auto",
                                                    attrs: {
                                                      src: _vm.themeImage(
                                                        item.key
                                                      ),
                                                      position: "top",
                                                      height: "860",
                                                      "max-height": "860"
                                                    }
                                                  }),
                                                  _c(
                                                    "gg-btn",
                                                    {
                                                      attrs: {
                                                        block: "",
                                                        tile: "",
                                                        color: active
                                                          ? "primary"
                                                          : "white",
                                                        href: item.url,
                                                        target: "_blank"
                                                      },
                                                      on: {
                                                        click: function click(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Visit Demo Site "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }